module.exports = __webpack_public_path__ + "img/pin.8d08291e.png";